/**
 * @Author: v_jppjpeng
 * @Date: 2025-02-07 10:17:38
 * @Explain: ab测试
 */

export default {
  // 旧版 活动管理 - 创建ab测试
  'ACTIVITY.AB.TEST.FROM.TIPS': '发送测试的是谁？',
  'ACTIVITY.AB.TEST.TO.TIPS': '您要把测试发给谁？',
  'ACTIVITY.AB.TEST.PLEASE.ENTER.PROPORTION': '请输入',
  'ACTIVITY.AB.TEST.TWO.DECIMAL.PLACES': '保留2位小数',
  'ACTIVITY.AB.TEST.GREATER.THAN.0': '输入数字需要大于0',
  'ACTIVITY.AB.TEST.SUM.100': '相加总和需要等于100',

  // 旧版 活动管理 - 创建ab测试 - 实验设置
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING': '配置测试',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SUBJECT': '主题',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.TIPS': '配置测试变量及实验组比例',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.MIN.TIPS': '最少设置{num}个实验组',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.MAX.TIPS': '最多设置{num}个实验组',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SELECTED': '<b>{num} 主题</b>已配置',
  'ACTIVITY.MANAGE.EXPERIMENT.VARIABLES': '实验变量',
  'ACTIVITY.MANAGE.EXPERIMENT.GROUP.PROPORTION': '实验组比例',
  'ACTIVITY.MANAGE.EXPERIMENT.PLEASE.ENTER.GROUP.PROPORTION': '请输入',
  'ACTIVITY.MANAGE.EXPERIMENT.ORDER': '实验{num}',
  'ACTIVITY.MANAGE.EXPERIMENT.SUBJECT.PLACEHOLDER': '输入主题{num}',
  'ACTIVITY.MANAGE.EXPERIMENT.CONFIGURED.SUBJECT': '已配置{num}个',
  'ACTIVITY.MANAGE.EXPERIMENT.NOT.CONFIGURED.SUBJECT': '未配置',
  'ACTIVITY.MANAGE.EXPERIMENT.NOT.CONFIGURED.SUBJECT.TIPS':
    '该语言下主题和预览文本在配置实验时未配置，为收件人发送默认语言下主题。',
  'ACTIVITY.MANAGE.EXPERIMENT.SETTING.SUBJECT.PREVIEW.TEXT': '主题及预览文本',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.TITLE': '风险提示',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.DESC1':
    '单组人数低于{maxNum}，样本量较小，实验结果可能不科学。',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.DESC2':
    '建议调整活动收件人或分组数及分组比例比例。',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.BACK.EDIT': '返回修改',
  'ACTIVITY.MANAGE.EXPERIMENT.NUMBER.PEOPLE.LIMIT.CONFIRM.SET': '确认设置',

  // 活动管理 - ab测试 - 列表
  // 'ACTIVITY.AB.TEST.LIST.ALL.TEST': '所有测试',
  'ACTIVITY.AB.TEST.LIST.CARD.TITLE': '测试列表',
  'ACTIVITY.AB.TEST.LIST.SEARCH.TAG.PLACEHOLDER': '请输入测试名称',
  'ACTIVITY.AB.TEST.LIST.CREATE.TEST': '创建测试',
  'ACTIVITY.AB.TEST.LIST.CREATE.TEST.NAME': '测试名称',
  'ACTIVITY.AB.TEST.LIST.CREATE.ENTER.TEST.NAME': '输入名称',
  'ACTIVITY.AB.TEST.LIST.TEST.NAME.EXIST': '当前输入的测试名称已存在',
  'ACTIVITY.AB.TEST.LIST.CREATE.DESC1':
    '创建并发布测试，在几分钟内可以完成配置测试人群、配置测试变量和配置测试邮件。',

  'ACTIVITY.AB.TEST.LIST.UNPUBLISHED.NOTES':
    '测试为未创建完成，暂存状态，编辑后可直接发布或申请发布。',
  'ACTIVITY.AB.TEST.LIST.UNDER.APPROVAL.NOTES': '测试已申请发布，等待审批中。',
  'ACTIVITY.AB.TEST.LIST.HAVE.IN.HAND.NOTES':
    '活动被发布成功，且已经到达设置的发送时间，正常投递中。',
  'ACTIVITY.AB.TEST.LIST.SUSPENDED.NOTES':
    '进行中的活动，被手动暂停。当前不再发送邮件',

  'ACTIVITY.AB.TEST.LIST.TEST.DETAILS': '测试详情',
  'ACTIVITY.AB.TEST.DELETE.DIALOG.HEADER': '确定删除其测试吗？',
  'ACTIVITY.AB.TEST.DELETE.DIALOG.CONTENT':
    '删除任务 {name} 该任务将不能继续使用',
  'ACTIVITY.AB.TEST.BATCH.DELETE.DIALOG.HEADER': '确定删除吗？',

  // 活动管理 - 创建ab测试 - 收件人
  'ACTIVITY.AB.TEST.RECIPIENTS': '收件人',

  // 活动管理 - 创建ab测试 - 测试设置
  'ACTIVITY.AB.TEST.SETUP': '测试组',
  'ACTIVITY.AB.TEST.SETUP.SUB.TITLE': '配置测试组的大小和获胜条件',

  // 测试分流比
  'ACTIVITY.AB.TEST.SPLIT.RATIO.TITLE': '测试组人数占比',

  // 你要测试主题和预览文本的数量
  'ACTIVITY.AB.TEST.EXPERIMENTAL.GROUP.TITLE': '变量数量',

  // 获胜标准
  'ACTIVITY.AB.TEST.WINNING.SELECTION.RULE.TITLE': '获胜组选择规则',
  'ACTIVITY.AB.TEST.WINNING.SELECTION.RULE.TIPS':
    '获胜组以测试结束后的 {num}内邮件打开率为判定标准，超时数据不计入评选，确保公平性。',

  'ACTIVITY.AB.TEST.SELECT.MANUALLY.TIPS':
    '测试结束后，你可以在活动报表手动选择获胜组。如果你在测试结束后的三天内没有手动选择，将会自动选择打开率最好的一组为获胜组。',

  'ACTIVITY.AB.TEST.WINNING.CRITERIA': '获胜标准',
  'ACTIVITY.AB.TEST.SELECT.MANUALLY': '手动选择',
  'ACTIVITY.AB.TEST.BY.OPEN.RATE': '按打开率',
  'ACTIVITY.AB.TEST.WAIT.TIME': '等待时间',
  'ACTIVITY.AB.TEST.WAIT.TIME.TIPS': '此处设置的是活动结束后的等待时间',
  'ACTIVITY.AB.TEST.WAIT.TIME.PLACEHOLDER': '请输入等待时间',
  'ACTIVITY.AB.TEST.WAIT.TIME.REG': '请输入1-99的整数',
  'ACTIVITY.AB.TEST.HOURS': '小时',
  'ACTIVITY.AB.TEST.DAYS': '天',
  'ACTIVITY.AB.TEST.WAIT.TIME.WARNING':
    '我们建议至少等待<b>{ num }</b>收集所有结果。',

  // 想要按地区或语言分别确认获胜组？
  'ACTIVITY.AB.TEST.WINNING.GROUP.BY.LANG.OR.REGION':
    '想要分语言测试不同组的表现？',
  'ACTIVITY.AB.TEST.DIVIDED.SETTING.TITLE': '测试分组设置',
  'ACTIVITY.AB.TEST.DIVIDED.SETTING.DESC':
    '您可以根据用户特征将测试分为几组，独立确定每组的获胜者，并自动将获胜者传递给相应的组。',
  'ACTIVITY.AB.TEST.DISABLED': '禁用',
  'ACTIVITY.AB.TEST.DIVIDED.BY.LANGUAGE': '按语言划分',
  'ACTIVITY.AB.TEST.DIVIDED.BY.LOCATION': '按地点划分',
  'ACTIVITY.AB.TEST.ORGANISE.LANGUAGE': '组织语言',
  'ACTIVITY.AB.TEST.MERGE.LANGUAGE.DESC':
    "我们将把以下语言合并到一个<b class='color-333'>“其他”</b>组中，确保每个设置都有足够的收件人",

  // 测试设置 - 总结
  'ACTIVITY.AB.TEST.SUMMARY.TITLE': '小节',
  'ACTIVITY.AB.TEST.TOTAL.RECIPIENTS': '总计',
  'ACTIVITY.AB.TEST.RECIPIENTS.FOR.TEST': '用于测试',
  'ACTIVITY.AB.TEST.RECIPIENTS.TEST': '测试人数',
  'ACTIVITY.AB.TEST.RECIPIENTS.PER.SETUP': '每组人数',
  'ACTIVITY.AB.TEST.LANGUAGE.DIVIDED.TITLE': '按语言划分每组人数',
  'ACTIVITY.AB.TEST.LANGUAGE.DIVIDED.TIPS':
    '获胜组是针对每种语言独立确定的，确保将每个语种最佳表现的主题传递给对应语言的收件人。',
  'ACTIVITY.AB.TEST.MIN.RECIPIENT.TIPS':
    '我们建议每个测试组至少有{num}个收件人。',
  'ACTIVITY.AB.TEST.SUMMARY.FORECAST.TIPS': '所有数据均为基于当前条件的估计值',

  // 活动管理 - 创建ab测试 - 设置主题、预览文本
  'ACTIVITY.AB.TEST.VARIABLES': '变量',
  'ACTIVITY.AB.TEST.VARIABLES.SUB.TITLE': '配置变量',

  // 活动管理 - 创建ab测试 - 配置活动信息
  'ACTIVITY.AB.TEST.BASE.INFO.TITLE': '内容',
  'ACTIVITY.AB.TEST.BASE.INFO.SUB.TITLE': '为所有组配置活动信息',

  // 活动管理 - 创建ab测试 - 详情总结
  'ACTIVITY.AB.TEST.DETAILS.REVIEW.CONFIRM': '检查',
  'ACTIVITY.AB.TEST.DETAILS.REVIEW.CONFIRM.TITLE': '检查并确认',
  'ACTIVITY.AB.TEST.DETAILS.RECIPIENTS': '收件人',
  'ACTIVITY.AB.TEST.DETAILS.SETUP.DIVIDED.SETTING': '划分设置',
  'ACTIVITY.AB.TEST.DETAILS.TEST.SPLIT.RATIO': '测试人数（占比&人数）',
  'ACTIVITY.AB.TEST.DETAILS.WINNING.CRITERIA': '获胜条件',
  'ACTIVITY.AB.TEST.DETAILS.WAIT.NUM': '等待 {num} ',
  'ACTIVITY.AB.TEST.DETAILS.NUMBER.OF.SETUP': '测试分组（组数&每组人数）',
  'ACTIVITY.AB.TEST.DETAILS.SEND.TIME': '发送时间',
  'ACTIVITY.AB.TEST.SUMMARY.DETAILS.TIPS1': '已在<b>{time}</b>手动选择获胜组，',
  'ACTIVITY.AB.TEST.SUMMARY.SEE.DETAILS': '查看详情',

  // 按钮
  'ACTIVITY.AB.TEST.SEND.TEST.EMAIL': '发送测试邮件',
  'ACTIVITY.AB.TEST.SEND.TEST.EMAIL.TIPS': '请完成所有必需的步骤',
  'ACTIVITY.AB.TEST.SAVE.DRAFT': '保存草稿',
  'ACTIVITY.AB.TEST.NEXT': '下一步',
  'ACTIVITY.AB.TEST.SUBMIT.FOR.APPROVAL': '提交审批',
};
